import { render, staticRenderFns } from "./ReciboComitente.vue?vue&type=template&id=3f8f3232&"
import script from "./ReciboComitente.vue?vue&type=script&lang=js&"
export * from "./ReciboComitente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports